module.exports = __webpack_public_path__ + "static/media/timer-win.e6a7fcf9.png";